import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import Discount from '../../entities/discount';

/*
 * Delete/nullify anywhere this discount is used in other entities
 *
 * @param {Discount} discount
 */
export function deleteDiscount(discount: Discount, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = discount.id;
    }

    /* Remove the actual discount */
    discount.status = 'D';
    discount.addedOn = newHRTimestamp();
    discount.addedBy = getCurrentUserId();
    discount.importSource = targetImportSource;
    discount.importId = mergeId;
    store.dispatch(Actions.DiscountActions.removeDiscountQueue(discount));
    
}